var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoCalculVolumeEauSansTexte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.845,
    height: 44.845,
    viewBox: "8.753 -2.615 44.845 44.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "picto_calcul_volume_eau",
    "data-name": "picto calcul volume eau",
    transform: "translate(10.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_104",
    "data-name": "Trac\\xE9 104",
    d: "M13.212,19.77a8.085,8.085,0,0,1-3.673-.88l-.55-.28a7.059,7.059,0,0,0-6.1-.156L1.3,19.162l-.407-.914,1.587-.708a8.051,8.051,0,0,1,6.966.179l.549.28a7.1,7.1,0,0,0,5.724.314L19.179,17a8.064,8.064,0,0,1,6.894.555,7.052,7.052,0,0,0,6.886.1l.291-.157a8.108,8.108,0,0,1,8.058.237l.157.1-.527.85-.156-.1a7.11,7.11,0,0,0-7.06-.206l-.291.156a8.038,8.038,0,0,1-7.857-.116,7.064,7.064,0,0,0-6.042-.486l-3.462,1.31a8.089,8.089,0,0,1-2.858.521",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_105",
    "data-name": "Trac\\xE9 105",
    d: "M13.4,23.664a8.085,8.085,0,0,1-3.673-.88l-.55-.28a7.059,7.059,0,0,0-6.1-.156l-1.587.708-.407-.914,1.587-.708a8.049,8.049,0,0,1,6.965.179l.55.28a7.1,7.1,0,0,0,5.724.314L19.37,20.9a8.058,8.058,0,0,1,6.894.555,7.042,7.042,0,0,0,6.886.1l.291-.157a8.115,8.115,0,0,1,8.058.237l.157.1-.526.85-.156-.1a7.117,7.117,0,0,0-7.061-.206l-.291.156a8.027,8.027,0,0,1-7.857-.116,7.067,7.067,0,0,0-6.042-.486l-3.462,1.31a8.089,8.089,0,0,1-2.858.521",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_106",
    "data-name": "Trac\\xE9 106",
    d: "M20.16,17.213a.5.5,0,0,1-.5-.5V4.33a4.33,4.33,0,1,1,8.659,0V6.244a.5.5,0,1,1-1,0V4.33a3.33,3.33,0,1,0-6.659,0V16.713a.5.5,0,0,1-.5.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_107",
    "data-name": "Trac\\xE9 107",
    d: "M31.649,18.744a.5.5,0,0,1-.5-.5V5.861a4.33,4.33,0,0,1,8.66,0V7.776a.5.5,0,0,1-1,0V5.861a3.33,3.33,0,0,0-6.66,0V18.244a.5.5,0,0,1-.5.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_108",
    "data-name": "Trac\\xE9 108",
    d: "M31.7,10.088H20.45a.5.5,0,0,1,0-1H31.7a.5.5,0,0,1,0,1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_109",
    "data-name": "Trac\\xE9 109",
    d: "M31.574,14.812H20.323a.5.5,0,0,1,0-1H31.574a.5.5,0,1,1,0,1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_110",
    "data-name": "Trac\\xE9 110",
    d: "M41.845,39.681H.5a.5.5,0,0,1,0-1H40.845V9.129a.5.5,0,0,1,1,0Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoCalculVolumeEauSansTexte);
export default __webpack_public_path__ + "static/media/picto_calcul_volume_eau_sans_texte.06ceae8a165a6c43cdfd37e0b316316f.svg";
export { ForwardRef as ReactComponent };